
import raise from './raise.png';
import zapierlogo from './zapierlogo.png';


export { default as SentIcon } from './icon_sent';
export const raiseIcon = raise;
export const zapierIcon = zapierlogo;

export { default as PlanFreeIcon } from './icon_plan_free';
export { default as PlanStarterIcon } from './icon_plan_starter';
export { default as PlanPremiumIcon } from './icon_plan_premium';
